import { createSlice, createSelector } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  selectedValues: {} // Stores selected checkboxes for multiple fields
};

// Create Redux slice
const checkboxSlice = createSlice({
  name: "checkbox",
  initialState,
  reducers: {
    toggleCheckbox: (state, action) => {
      const { stateName, value } = action.payload;
      const parsedValue = parseInt(value, 10); // Ensure integer storage

      // Initialize if not set
      if (!state.selectedValues[stateName]) {
        state.selectedValues[stateName] = [];
      }

      // Toggle the selection
      if (state.selectedValues[stateName].includes(parsedValue)) {
        state.selectedValues[stateName] = state.selectedValues[stateName].filter((item) => item !== parsedValue);
      } else {
        state.selectedValues[stateName].push(parsedValue);
      }
    }
  }
});

// Selector using `reselect` to optimize performance
const selectCheckboxState = (state) => state.checkbox.selectedValues;
export const selectCheckboxValues = createSelector(
  [selectCheckboxState, (_, stateName) => stateName],
  (selectedValues, stateName) => selectedValues[stateName] || [] // Return an empty array if undefined
);

// Export actions and reducer
export const { toggleCheckbox } = checkboxSlice.actions;
export default checkboxSlice.reducer;
